// extracted by mini-css-extract-plugin
export var hiddenText = "style-module--hidden-text--ee6f7";